export default "__VITE_ASSET__Np2tSb6$__"